import { render, staticRenderFns } from "./noticeModel.vue?vue&type=template&id=36448df2&lang=pug&"
import script from "./noticeModel.vue?vue&type=script&lang=js&"
export * from "./noticeModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports